import { useReportingPeriodTimelineController } from "./useReportingPeriodTimelineController";
import { LoadingState } from "./components/LoadingState";
import { EmptyState } from "./components/EmptyState";
import { TimelineContainer } from "./components/TimelineContainer";

import "./styles.css";
import { useEffect } from "react";

export function ReportingPeriodTimeline() {
  const controller = useReportingPeriodTimelineController();
  // Scroll to the selected period when it changes
  useEffect(() => {
    if (controller.selectedReportingPeriod && controller.timelineRef.current) {
      const selectedElement = document.getElementById(
        `period-${controller.selectedReportingPeriod.reportingPeriodId}`
      );

      if (selectedElement) {
        // Calculate the center position for the selected period
        const containerWidth = controller.timelineRef.current.offsetWidth;
        const scrollPosition =
          selectedElement.offsetLeft -
          containerWidth / 2 +
          selectedElement.offsetWidth / 2;

        controller.timelineRef.current.scrollTo({
          left: scrollPosition,
          behavior: "smooth",
        });
      }
    }
  }, [controller.selectedReportingPeriod]);

  if (controller.isLoading) {
    return <LoadingState />;
  }

  if (!controller.selectedFund) {
    return <EmptyState noFundSelected={true} />;
  }

  if (controller.periodsWithSpacing.length === 0) {
    return <EmptyState onCreatePeriod={controller.createPeriod} />;
  }

  return (
    <TimelineContainer
      timelineRef={controller.timelineRef}
      periodsWithSpacing={controller.periodsWithSpacing}
      selectedReportingPeriod={controller.selectedReportingPeriod}
      onSelectPeriod={controller.handleSelectPeriod}
      onCreatePeriod={controller.createPeriod}
      toggleStatus={controller.updatePeriod}
    />
  );
}
